import type {
    IPayTecDisconnectCmd,
    IPayTecPairAndConnectCmd,
    IPayTecPaymentDeviceConnection,
} from "@/data/commands/paymentDevice/IPayTecPairAndConnectCmd";
import { BaseServiceDao } from "@/data/dao/service/BaseServiceDao";

export class PaymentDeviceDao extends BaseServiceDao {
    public static className = "PaymentDeviceDao";

    constructor() {
        super("payment-device");
    }

    public async payTecPairAndConnect(cmd: IPayTecPairAndConnectCmd): Promise<IPayTecPaymentDeviceConnection> {
        return this.post("paytec/pair-and-connect", cmd, (l) =>
            PaymentDeviceDao.parsePayTecPaymentDeviceConnection(l)
        );
    }


    public async payTecDisconnect(cmd: IPayTecDisconnectCmd): Promise<void> {
        return this.post("paytec/disconnect", cmd);
    }

    public static parsePayTecPaymentDeviceConnection(literal: any): IPayTecPaymentDeviceConnection {
        return {
            accessToken: literal.accessToken,
            paymentDeviceId: literal.paymentDeviceId,
        };
    }
}
